jQuery(function ($) {
    $('.ck-hero__slider').each(function () {
        const $slider = $(this);
        if ($slider.hasClass('slick-initialized')) return;

        $slider.slick({
            dots: true,
            arrows: false,
            infinite: true,
            autoplay: $slider.data('autoplay') !== false,
            autoplaySpeed: 6000,
            speed: 700,
            fade: true,
            pauseOnHover: false,
            adaptiveHeight: false,
        });
    });
});
